// extracted by mini-css-extract-plugin
export var attachment = "_pl-a";
export var emailContainer = "_pl-4";
export var emailContentPaddedContainer = "_pl-b";
export var emailHeader = "_pl-6";
export var emailIframe = "_pl-3";
export var emailInfoIcon = "_pl-9";
export var emailShortenedSummary = "_pl-e";
export var infoDropdown = "_pl-0";
export var infoRowBoundedContent = "_pl-d";
export var internal = "_pl-5";
export var merchant = "_pl-8";
export var messageInputContainer = "_pl-h";
export var normal = "_pl-7";
export var replyCard = "_pl-f";
export var subtleButton = "_pl-1";
export var subtleButtonIconContainer = "_pl-2";
export var toggleViewRepliesButton = "_pl-c";
export var wrappingText = "_pl-g";